import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Login from './Component';
import actions from '../../pages/Login/actions';
import selectors from './selectors';
import startupConfigSelectors from '../../components/StartupConfig/selectors';
import checkOutSummarySelectors from '../../components/CheckOutSummary/selectors';
import getInitialDataSelectors from '../../components/GetDetailsFromRoute/selectors';

const mapStateToProps: any = createSelector(
  selectors.selectStep,
  checkOutSummarySelectors.selectCheckOut,
  selectors.selectMobileNumber,
  getInitialDataSelectors.selectContext,
  startupConfigSelectors.selectConfiguration,
  (step, checkOut, mobileNumber, context, configuration) => ({
    step: step ? step : 0,
    checkOut,
    mobileNumber,
    context,
    configuration,
  })
);

const mapDispatchToProps: any = (dispatch: any) => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Login);
